import { ITranslateObject, SupportedLanguage } from "@app/views-interfaces";

interface CompareByFirstAndLastNames {
    FirstName: string;
    LastName: string;
}

type CompareByActiveAndName = CompareByFirstAndLastNames & { Active: boolean };

export function compareByFirstAndLastNames<T extends CompareByFirstAndLastNames>(a: T, b: T): number {
    return a.FirstName.localeCompare(b.FirstName) || a.LastName.localeCompare(b.LastName);
}

export function compareByActiveAndName<T extends CompareByActiveAndName>(a: T, b: T): number {
    return Number(b.Active) - Number(a.Active) || compareByFirstAndLastNames(a, b);
}

type CompareByLocalizedNameNoneFirst = ITranslateObject & { Id: number | string };

export function compareByLocalizedName<T extends ITranslateObject>(a: T, b: T, language: SupportedLanguage): number {
    return (a[language] || "").localeCompare(b[language] || "", undefined, { sensitivity: "base" });
}

export function compareByLocalizedNameNoneFirst<T extends CompareByLocalizedNameNoneFirst>(a: T, b: T, language: SupportedLanguage): number {
    if (a.Id === -1) return -1;
    if (b.Id === -1) return 1;
    return compareByLocalizedName(a, b, language);
}
